import { styled } from '@mui/material';

export const StyledContainer = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: 0,
  paddingInlineStart: '0px',
  listStyleType: 'none',
}));
export const StyledTitle = styled('li')(({ theme }) => ({
  paddingTop: '16px',
  '& > span': {
    fontWeight: 700,
    fontFamily: 'Verdana',
  },
  '@media only screen and (max-width: 768px)': {
    paddingTop: '16px',
  },
}));

export const StyledDescription = styled('li')(({ theme }) => ({
  padding: '8px 0 12px',
  '@media only screen and (max-width: 768px)': {
    padding: '24px 0 0px',
  },
}));
